module.exports = __webpack_public_path__ + "img/thumb_07.3074ef3d.jpg";